// src/components/LoadingScreen.jsx
import React from "react";

export default function LoadingScreen({
  variant = "loading", // loading | error
  title,
  message = "در حال بارگذاری...",
  onRetry,
}) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        padding: 24,
        textAlign: "center",
        background: "var(--bg)",
        color: "var(--ink)",
        fontFamily: "'Vazirmatn', Tahoma, sans-serif",
      }}
    >
      {variant === "loading" ? (
        <div className="spinner" />
      ) : (
        <div style={{ fontSize: 44, lineHeight: 1, color: "var(--muted)" }}>
          <i
            className={`fa-solid ${
              navigator.onLine === false ? "fa-wifi" : "fa-triangle-exclamation"
            }`}
          />
        </div>
      )}

      {title && (
        <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{title}</h2>
      )}
      <p style={{ color: "var(--muted)", fontSize: 14, margin: 0 }}>
        {message}
      </p>

      {onRetry && (
        <button className="btn" onClick={onRetry} style={{ marginTop: 6 }}>
          <i className="fa-solid fa-rotate-right" /> تلاش دوباره
        </button>
      )}

      <style>{`
        .spinner {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 3px solid var(--border-strong);
          border-top-color: var(--accent);
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
